import * as yup from "yup";

const schema = yup.object().shape({
  password: yup.string().required().label("Password"),
  passwordConfirm: yup
    .string()
    .test("passwords-match", "Passwords must match", function (value) {
      return this.parent.password === value;
    })
    .label("Password Confirmation"),
});

export default schema;
